var map = {
	"./Classic Template/SingleMenuPage": [
		8156,
		607,
		856,
		116
	],
	"./Classic Template/SingleMenuPage/SingleMenuPage": [
		2856,
		607,
		856,
		525
	],
	"./Pizza Restaurant/SingleMenuPage": [
		6851,
		664,
		747,
		857
	],
	"./Pizza Restaurant/SingleMenuPage/SingleMenuPage": [
		5747,
		664,
		747,
		251
	],
	"./Sushi Restaurant/SingleMenuPage": [
		6035,
		607,
		939,
		517
	],
	"./Sushi Restaurant/SingleMenuPage/SingleMenuPage": [
		5939,
		607,
		939,
		535
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2379;
module.exports = webpackAsyncContext;